import { useCallback } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { WithBillId } from '@mews-commander/types';
import { BillExtent, BillResult, useRepositoryQuery } from '@mews-commander/data-access';

const extent = {
    orderItems: true,
    products: false,
    payments: false,
    serviceOrders: false,
    notes: false,
    services: false,
    paymentCards: false,
    paymentProfiles: false,
    cashiers: false,
} satisfies BillExtent;

export const useBillReinstateDetails = ({ billId }: WithBillId) => {
    const select = useCallback(
        ({ bills, orderItems }: BillResult) => ({
            bill: bills?.find(({ id }) => id === billId),
            orderItems: orderItems?.filter((orderItem) => orderItem.billId === billId),
        }),
        [billId]
    );

    const { data, isFetching } = useRepositoryQuery(
        'bills',
        'getAll',
        { billIds: [billId], extent },
        { placeholderData: keepPreviousData, select }
    );

    return { bill: data?.bill, orderItems: data?.orderItems, isFetching };
};
